import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export const getRemainingTimeInMs = (submissionId: number) =>
  restApiClient
    .url(constructApiUrl(API.languageTest.getRemainingTime.url, { submissionId }))
    .get<number>()
